import { FC } from 'react';

import { RouterProvider } from '@app/providers/router-provider';
import { StoreProvider } from '@app/providers/store-provider';
import * as serviceWorkerRegistration from '@assets/pwa/serviceWorkerRegistration';

export const App: FC = () => {
	return (
		<StoreProvider>
			<RouterProvider />
		</StoreProvider>
	);
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
